import React from 'react';
import DynaInput from "../../../DynaView/DynaInput";
import RowShowLevel from "./RowShowLevel";

const DetailDocumentIssuance = ({sendData, setSendData}) => {

  return (
    <div className={"DetailDocumentIssuance"}>

      <DynaInput label={"توضیحات"}
                 name={"documentDescription"}
                 className={"solid-dyna-input"}
                 placeholder={"توضیحات را وارد کنید"}
                 value={sendData?.documentDescription}
                 type={"text"}
                 setDataFromComponent={(data) => {
                   setSendData({...sendData, ...data})
                 }}
      />

      <RowShowLevel sendData={sendData} setSendData={setSendData}/>

    </div>
  );
};

export default DetailDocumentIssuance;